import { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';

import { useGetWorkingAreasSelector} from '../../hooks/useWorkingAreasService';

import { Typography } from '@mui/material';
import Header from '../../components/Header/Header';
import BottomMenu from '../../components/BottomMenu/BottomMenu';
import WorkingAreasList from '../../components/WorkingAreasList/WorkingAreasList';
import SimpleWorkingAreaCard from '../../components/SimpleWorkingAreaCard/SimpleWorkingAreaCard';

import './WorkingAreas.scss';

function WorkingAreas() {
  const navigate = useNavigate();
  const { authUser, isAuthorized } = useContext(AuthContext);

  const [ , workingAreas, agentWorkingArea] = useGetWorkingAreasSelector({
    cityId: authUser?.roles?.agent?.city?.id,
    agentId: authUser?.roles?.agent?.id
  });

  useEffect(() => {
    if (!isAuthorized) navigate('/login');
  }, [isAuthorized, navigate]);

  function handleGoToWorkingAreaDetails(workingAreaId) {
    navigate('/working-area', {
      state: {
        workingAreaId
      }
    });
  }

  const agentAreaId = agentWorkingArea?.id;
  const agentAreaDescription = agentWorkingArea?.description;

  return (
    <div className="inner-page working-areas-page">
      <Header
        pageTitle="Áreas de Trabalho"
      />
      <div className="inner-page-content-container">
        <Typography className="section-title" variant="p" component="p">Sua área de trabalho</Typography>
        <SimpleWorkingAreaCard
          className="your-area"
          workingAreaId={agentAreaId}
          description={agentAreaDescription}
          showDetailsLabel
          handleGoToWorkingAreaDetails={handleGoToWorkingAreaDetails}
        />
        <Typography className="section-title" variant="p" component="p">Outras áreas na sua cidade</Typography>
        <WorkingAreasList
          areaToFilterOut={agentWorkingArea}
          workingAreas={workingAreas}
          maxHeight={"calc(100% - 100px)"}
          handleGoToWorkingAreaDetails={handleGoToWorkingAreaDetails}
        />
      </div>
      <BottomMenu />
    </div>
  );
}

export default WorkingAreas;
